<script>
	//TODOS
	// save users to db

	// Imports
	import { slide } from "svelte/transition";
	import {
		GoogleAuthProvider,
		signInWithPopup,
		signInAnonymously,
		onAuthStateChanged,
		updateProfile,
	} from "firebase/auth";
	import { ref, uploadString, getDownloadURL } from "firebase/storage";
	import {
		doc,
		collection,
		addDoc,
		setDoc,
		getDoc,
		getDocs,
		updateDoc,
		onSnapshot,
		query,
		where,
		limit,
		deleteField,
		serverTimestamp,
		increment,
	} from "firebase/firestore";
	import { logEvent } from "firebase/analytics";
	import { createName } from "../lib/nameGenerator";
	import { createImage } from "../lib/imageGenerator";
	import { uiText } from "../lib/uiText.js";
	import { makeID } from "../lib/makeID.js";
	import Messageboard from "./Messageboard.svelte";
	import { createEventDispatcher } from "svelte";
	import User from "./User.svelte";
	import { Recaptcha, recaptcha, observer } from "svelte-recaptcha-v2";
	import GameFooter from "./GameFooter.svelte";
	// import { loop } from 'svelte/internal';
	// import A4 from '../common/404.svelte';
	import Tutorial from "./Tutorial.svelte";

	const dispatch = createEventDispatcher();
	// import { useResolvable } from 'svelte-navigator';

	// Firebase
	const google = new GoogleAuthProvider();
	export let auth;
	export let analytics;
	export let db;
	export let storage;
	const googleRecaptchaSiteKey = "6LeNO3QfAAAAABvM7GziCSQxVs6Zgm4NljLxr9XF";
	let captchaState = "unset";

	// Global
	export let lang;
	export let user;
	export let loader;
	let showLangSelector = false;
	let showHelpInfo = false;
	let ui = uiText(lang);
	$: lang,
		(ui = uiText(lang)),
		dispatch("setLang", { lang: lang, prefset: true });
	$: loader, dispatch("loader", loader);

	// Local
	let msg_type = "info";
	let msg_content = "";
	let msg_shown = false;
	let msg_action = "Okay";
	let msg_color = false;
	let state = "login_buttons"; // login_buttons | anon_creator | user ...
	let stepstate = "rules"; //rules | ? headcount | new_captain_join | game_captain | game_join

	let agreedToRules = false;

	let anonUser = {
		name: "",
		photo: "",
	};

	let sessionData = {
		gameAccCode: "",
		teamName: "",
	};

	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	let gc = urlParams.get("gid") || urlParams.get("game") || false; //game code
	let fg = urlParams.get("fg") || urlParams.get("force") || false; //force game
	let gn = urlParams.get("gn") || urlParams.get("name") || false; //game name
	let lg = urlParams.get("login") || urlParams.get("log") || "ga"; //google/anonymously
	let ac = urlParams.get("access") || urlParams.get("ac") || false; //access/join code

	//GAME URL PARAMETERS FOR GAME

	if (gc) {
		sessionData.gameAccCode = gc;
	}
	if (ac) {
		sessionData.joinCode = ac;
	}

	// console.log(gc, gn, lg);

	function showMessage(message) {
		if (message.hasOwnProperty("msg_type")) {
			msg_type = message.msg_type;
		} else {
			msg_type = "default";
		}

		msg_content = message.msg_content;

		if (message.hasOwnProperty("msg_action")) {
			msg_action = message.msg_action;
		} else {
			msg_action = ui.message.default_okay;
		}

		if (message.hasOwnProperty("msg_color")) {
			msg_color = message.msg_color;
		} else {
			msg_color = false;
		}
		msg_shown = true;
	}

	function handleMessage(e) {
		// console.log('message:' + e.detail);
		if (e.detail.hasOwnProperty("msg_type")) {
			msg_type = e.detail.msg_type;
		} else {
			msg_type = "default";
		}

		msg_content = e.detail.msg_content;

		if (e.detail.hasOwnProperty("msg_action")) {
			msg_action = e.detail.msg_action;
		} else {
			msg_action = "Default Okay [193]";
		}

		if (e.detail.hasOwnProperty("msg_color")) {
			msg_color = e.detail.msg_color;
		} else {
			msg_color = false;
		}
		msg_shown = true;
		// console.log(msg_shown);
	}

	onAuthStateChanged(auth, (authUser) => {
		if (authUser) {
			// console.log(authUser);
			// list of available properties - https://firebase.google.com/docs/reference/js/firebase.User
			user.name = authUser.displayName;
			user.photo = authUser.photoURL;
			user.uid = authUser.uid;
			state = "user";

			checkActiveSession(authUser.uid);
		} else {
			state = "login_buttons";
			loader = false;
		}
	});

	async function checkActiveSession(authUID) {
		const actSesSnap = await getDoc(doc(db, "users", authUID));
		// console.log(175);
		if (actSesSnap.exists()) {
			let snapData = actSesSnap.data();
			// console.log(snapData);
			if (snapData.showConclusion) {
				state = "conclusion";
				dispatch("state", state);
			} else {
				if (snapData.hasActiveSession) {
					// console.log("has active sessn");
					state = "session";
					startListener(snapData.activeSessionID);
				} else {
					loader = false;
				}
			}
			// COME BACK HERE
		} else {
			// console.log('No active session can be found for this user!');
			loader = false;
		}
	}

	function authWithGoogle() {
		loader = true;
		signInWithPopup(auth, google)
			.then((result) => {
				digestUser("google", result);
				loader = false;
				logEvent(analytics, "logged_in_with_google");
			})
			.catch((error) => {
				console.warn(error);
				loader = false;
				// !!! add msgboard error.
				showMessage({
					msg_type: "error",
					msg_content: ui.message.google_login_error,
				});
			});
	}

	function authAnonymously() {
		loader = true;
		signInAnonymously(auth)
			.then((result) => {
				digestUser("anonymous", result);
				loader = false;
				logEvent(analytics, "logged_in_anonymously");
			})
			.catch((error) => {
				console.warn(error);
				loader = false;
			});
	}

	function anonymousCreator() {
		state = "anon_creator";
		create();
		//this could be done all inline
	}

	async function create(what) {
		if (what !== "image") {
			anonUser.name = await createName(lang);
		}
		anonUser.photo = await createImage(anonUser.name.charAt(0));
	}

	//

	function digestUser(method, data) {
		switch (method) {
			case "google":
				user.name = data.user.displayName;
				user.email = data.user.email;
				user.uid = data.user.uid;
				user.photo = data.user.photoURL;
				// console.log(data);
				// console.log(user);
				saveUser();
				break;

			case "anonymous":
				user.uid = data.user.uid;
				user.name = anonUser.name;

				const uploadRef = ref(
					storage,
					"user-images/prof-" + user.uid.slice(5, 30) + ".webp",
				);

				// console.log(uploadRef);
				uploadString(uploadRef, anonUser.photo, "base64", {
					contentType: "image/png",
				}).then((snapshot) => {
					//
					getDownloadURL(uploadRef)
						.then((url) => {
							user.photo = url;
							// console.log(url);

							// THIS WORKS
							updateProfile(auth.currentUser, {
								displayName: anonUser.name,
								photoURL: user.photo,
							})
								.then(() => {
									// console.log('Profile updated!');
									// ...
									saveUser();
								})
								.catch((error) => {
									// console.log(error);
									// ...
								});
							// THIS WORKS TILL HERE
						})
						.catch((error) => {
							// Handle any errors
						});
					// console.log(data.user);
					//
				});
				break;

			default:
		}
	}

	//

	async function saveUser() {
		const userRef = doc(db, "users", user.uid);
		await setDoc(
			userRef,
			{
				uid: user.uid,
				name: user.name,
				profile_pic: user.photo,
				email: user.email,
			},
			{ merge: true },
		);
	}

	//
	// async function createSession() {
	//     console.log(sessionData);
	// }

	let nextstepstate;
	function nextStep(e) {
		if (e.charCode === 13 || e.code === "Enter") {
			stepstate = nextstepstate;
		}
	}

	async function newGame() {
		//CHANGE Fn NAME
		const accCodeRef =
			sessionData.gameAccCode.substring(0, 3) == "BNR"
				? doc(
						db,
						"public-signups/bnr25/game-activation-codes",
						sessionData.gameAccCode,
					)
				: sessionData.gameAccCode.substring(0, 2) == "P-"
					? doc(
							db,
							"public-signups/general-public-signups/game-activation-codes",
							sessionData.gameAccCode,
						)
					: doc(db, "game-activation-codes", sessionData.gameAccCode);

		const accCodeSnap = await getDoc(accCodeRef);

		if (accCodeSnap.exists()) {
			// console.log('Document data:', accCodeSnap.data());
			if (
				accCodeSnap.data().used_by &&
				accCodeSnap.data().game_on === false &&
				!accCodeSnap.data().unlimited
			) {
				// console.log(
				//     'This code is already used by another user, but you can still join - just ask them for the join key.'
				// );
				showMessage({
					msg_type: "error",
					msg_content: ui.message.activation_code_used_can_join_error,
				});
			} else {
				// console.log(accCodeSnap.data().used_by);
				// console.log(accCodeSnap.data().unlimited);
				if (
					accCodeSnap.data().used_by === null ||
					accCodeSnap.data().unlimited
				) {
					if (
						accCodeSnap.data().use_limit &&
						accCodeSnap.data().use_limit <= accCodeSnap.data().use_count
					) {
						showMessage({
							msg_type: "error",
							msg_content: ui.message.activation_code_use_limit_error,
						});
					} else {
						sessionData.gameCode = accCodeSnap.data().product;

						// MAX TEAM SIZE HERE

						accCodeSnap.data().playersLimit !== null
							? (sessionData.gameLimit = accCodeSnap.data().playersLimit)
							: (sessionData.gameLimit = false);

						// console.log(340, sessionData.gameLimit);

						// MAX TEAM SIZE HERE

						sessionData.gameName = accCodeSnap.data().productName;
						sessionData.activationCode = accCodeSnap.data().code;
						// console.log(sessionData);
						newSession();
					}
				} else {
					// console.log('This code is already used by another user.');
					showMessage({
						msg_type: "error",
						msg_content: ui.message.activation_code_used_error,
					});
				}
			}
		} else {
			// console.log('No such document!');
			showMessage({
				msg_type: "error",
				msg_content: ui.message.game_not_found_error,
			});
		}
	}
	async function newSession() {
		//CHANGE Fn NAME
		const gameCodeRef = doc(db, "games", sessionData.gameCode);
		const gameCodeSnap = await getDoc(gameCodeRef);

		if (gameCodeSnap.exists()) {
			if (typeof gameCodeSnap.data().period !== "undefined") {
				if (
					gameCodeSnap.data().period.from.toDate() < Date.now() &&
					gameCodeSnap.data().period.to.toDate() > Date.now()
				) {
					// console.log('Period is valid!');
					// console.log(gameCodeSnap.data());
					sessionData.gameLimit
						? (sessionData.gameLimit = sessionData.gameLimit)
						: (sessionData.gameLimit = gameCodeSnap.data().max_team_size);
					// MAX TEAM SIZE HERE
					sessionData.displayGameName = gameCodeSnap.data().name;
					sessionData.startingLocation = gameCodeSnap.data().start || false;
					sessionData.variant = gameCodeSnap.data().variant || "default";
					// get this for session creation

					// const accCodeRef = doc(
					// 	db,
					// 	"game-activation-codes",
					// 	sessionData.gameAccCode
					// );
					// const accCodeRef =
					// 	sessionData.gameAccCode.substring(0, 3) == "BNR"
					// 		? doc(
					// 				db,
					// 				"public-signups/bnr25/game-activation-codes",
					// 				sessionData.gameAccCode,
					// 			)
					// 		: doc(db, "game-activation-codes", sessionData.gameAccCode);
					const accCodeRef =
						sessionData.gameAccCode.substring(0, 3) == "BNR"
							? doc(
									db,
									"public-signups/bnr25/game-activation-codes",
									sessionData.gameAccCode,
								)
							: sessionData.gameAccCode.substring(0, 2) == "P-"
								? doc(
										db,
										"public-signups/general-public-signups/game-activation-codes",
										sessionData.gameAccCode,
									)
								: doc(db, "game-activation-codes", sessionData.gameAccCode);
					await updateDoc(accCodeRef, {
						used_by: { uid: user.uid, name: user.name },
						use_count: increment(1),
					});

					generateSession();
				} else {
					// console.log('No valid period!');
					showMessage({
						msg_type: "error",
						msg_content: ui.message.game_inactive_error,
					});
					return false;
				}
			} else {
				// console.warn('no period set on this game');
				showMessage({
					msg_type: "error",
					msg_content: ui.message.game_inactive_error,
				});
				return false;
			}
		} else {
			// console.log('No such document!');
			// msgLog("error", "No game is found with this code.");
			showMessage({
				msg_type: "error",
				msg_content: ui.message.game_not_found_error,
			});
			return false;
		}
	}

	async function generateSession() {
		// CHANGE Fn NAME
		logEvent(analytics, "new_session_created");

		const newSessionSnap = await addDoc(collection(db, "sessions"), {});

		// console.log('Document written with ID: ', newSessionSnap.id);

		let newSessionData = {
			access_code: makeID(5),
			current_task: null,
			orderGID: sessionData.gameCode,
			orderSessionCreated: serverTimestamp(),

			game: {
				gid: sessionData.gameCode,
				name: sessionData.displayGameName,
				limit: sessionData.gameLimit,
				start: sessionData.startingLocation,
				// do this during session createSession
			},
			session: {
				sid: newSessionSnap.id,
				team_name: sessionData.teamName,
				players: {
					[user.uid]: {
						uid: user.uid,
						name: user.name,
						pic: user.photo,
						role: "captain",
					},
				},
				activation_code: sessionData.activationCode,
			},
			teamVariant: sessionData.variant,
		};

		await setDoc(newSessionSnap, newSessionData, { merge: true }).then(() => {
			addSessionToUser(newSessionData.session.sid);

			// console.log(317, 'Document successfully updated!');
			startListener(newSessionData.session.sid);
			showMessage({
				msg_type: "check",
				msg_content: ui.message.new_game_created_check,
			});
			// msgLog("check", 'A new game is created. You can invite your teammates to join via the code on your screen before you start the game. <br><br>Important! Once the game is started, no more people can join your team. Wait for everyone to join before you start the game.');
			// startListener(sessionData.sid);
		});
	}

	async function addSessionToUser(SID) {
		const userRef = doc(db, "users", user.uid);
		await setDoc(
			userRef,
			{ hasActiveSession: true, activeSessionID: SID, showConclusion: false },
			{ merge: true },
		);
	}

	async function getSessionID() {
		//change fn name
		const joinGameRef = query(
			collection(db, "sessions"),
			where("access_code", "==", sessionData.joinCode),
			limit(1),
		);

		const querySnapshot = await getDocs(joinGameRef);
		// console.log(querySnapshot.size);
		if (querySnapshot.size) {
			querySnapshot.forEach((doc) => {
				sessionData.joinSID = doc.id;
				joinSession();
			});
		} else {
			// console.warn('no such doc :( [348]');
			showMessage({
				msg_type: "error",
				msg_content:
					ui.message.default_error + "384 " + ui.message.default_error_end,
			});
		}
	}

	async function joinSession() {
		const joinSessionRef = doc(db, "sessions", sessionData.joinSID);
		const joinSessionSnap = await getDoc(joinSessionRef);
		let data = joinSessionSnap.data();
		// console.log(joinSessionSnap.id);
		if (data.access_code == sessionData.joinCode) {
			let playerCount = Object.keys(data.session.players).length;
			// console.log(playerCount);
			// console.log(data.game.limit);
			if (playerCount < data.game.limit) {
				//
				if (
					!data.session.ended ||
					data.session.ended == null ||
					data.session.ended == undefined
				) {
					// console.log(374, 'Before doc update');
					await updateDoc(
						joinSessionRef,
						{
							["session.players." + user.uid]: {
								uid: user.uid,
								name: user.name,
								pic: user.photo,
								role: "crew",
							},
						},
						{ merge: true },
					).then(() => {
						// console.log(374, 'Before doc add');
						addSessionToUser(joinSessionSnap.id);
						// console.log(374, 'Document successfully updated!');
						startListener(joinSessionSnap.id);
						logEvent(analytics, "session_joined");
					});
				} else {
					// console.warn("Sowy, the game's already over...");
					showMessage({
						msg_type: "error",
						msg_content: ui.message.game_already_over_error,
					});
				}
				//
			} else {
				// console.warn('too many ppl');
				showMessage({
					msg_type: "error",
					msg_content: ui.message.player_limit_error,
				});
			}
		} else {
			// console.log('No such document!');
			// msgLog("error", "No game is found with this code.");
			showMessage({
				msg_type: "error",
				msg_content: ui.message.game_not_found_error,
			});
		}
	}

	function startListener(listener) {
		const listenTo = listener || user.activeSessionID;
		const listening = onSnapshot(doc(db, "sessions", listenTo), (doc) => {
			const source = doc.metadata.hasPendingWrites ? "Local" : "Server";
			// console.log(source, ' data: ', doc.data());
			// console.log(sessionData);
			sessionData = doc.data();
			sessionData.session.playersArray = Object.values(
				sessionData.session.players,
			);
			if (sessionData.session.ended) {
				state = "conclusion";
				loader = true;
				dispatch("state", state);
			} else {
				if (sessionData.session.started) {
					state = "game";
					loader = true;
					dispatch("state", state);
				} else {
					loader = false;
				}
			}
			// console.log(sessionData);
		});
		// console.warn('Listener started!');
		state = "session";
		// console.log(state);
	}

	async function leaveSession() {
		const userRef = doc(db, "users", user.uid);
		const sessionRef = doc(db, "sessions", sessionData.session.sid);
		// deleteField()
		await updateDoc(
			userRef,
			{
				activeSessionID: deleteField(),
				hasActiveSession: false,
			},
			{ merge: true },
		);
		await updateDoc(
			sessionRef,
			{
				["session.players." + user.uid]: deleteField(),
			},
			{ merge: true },
		).then(() => {
			logEvent(analytics, "session_lobby_player_left");
			state = "user";
		});
	}

	async function startGameSession() {
		if (confirm(ui.new_join.start_game_confirm)) {
			// const accCodeRef = doc(
			// 	db,
			// 	"game-activation-codes",
			// 	sessionData.session.activation_code
			// );
			// const accCodeRef =
			// 	sessionData.session.activation_code.substring(0, 3) == "BNR"
			// 		? doc(
			// 				db,
			// 				"public-signups/bnr25/game-activation-codes",
			// 				sessionData.session.activation_code,
			// 			)
			// 		: doc(
			// 				db,
			// 				"game-activation-codes",
			// 				sessionData.session.activation_code,
			// 			);
			const accCodeRef =
				sessionData.session.activation_code.substring(0, 3) == "BNR"
					? doc(
							db,
							"public-signups/bnr25/game-activation-codes",
							sessionData.session.activation_code,
						)
					: sessionData.session.activation_code.substring(0, 2) == "P-"
						? doc(
								db,
								"public-signups/general-public-signups/game-activation-codes",
								sessionData.session.activation_code,
							)
						: doc(
								db,
								"game-activation-codes",
								sessionData.session.activation_code,
							);
			const sessionRef = doc(db, "sessions", sessionData.session.sid);
			// deleteField()
			await updateDoc(
				accCodeRef,
				{
					game_on: true,
				},
				{ merge: true },
			).then(async () => {
				await updateDoc(
					sessionRef,
					{
						["session.started"]: true,
						["session.sessionStart"]: serverTimestamp(),
						current_task: "aijacaqatierezipoca", //maybe change this at a later date
						orderSessionStart: serverTimestamp(),
					},
					{ merge: true },
				).then(() => {
					logEvent(analytics, "session_started");
					state = "game";
				});
			});
		}
	}

	// function copyCode(code) {
	// 	const copyText = code;
	// 	navigator.clipboard.writeText(copyText);
	// 	alert(ui.new_join.code_copy);
	// }

	function copyCode(code) {
		navigator.clipboard.writeText(code);
		// Alert the copied text
		// alert(ui.new_join.code_copy + " " + code);

		let tooltip = document.getElementById("myTooltip");
		tooltip.innerHTML = ui.new_join.code_copy;
	}

	function outFunc() {
		let tooltip = document.getElementById("myTooltip");
		tooltip.innerHTML = ui.new_join.copy_code;
	}
</script>

<Messageboard
	{msg_type}
	{msg_content}
	{msg_shown}
	{msg_action}
	{msg_color}
	on:msg={(e) => {
		msg_shown = e.detail;
		// console.log(e.detail);
	}}
/>
{#if !loader}
	<header
		class="box-border flex justify-between h-20 text-base bg-blue-100 obelisk"
	>
		<img
			class="hidden h-full max-h-full p-4 xs:block"
			src={lang === "bg" ? "/img/svg/logo-bg.svg" : "/img/svg/logo-en.svg"}
			alt={ui.game.footer.vendor}
		/>
		<img
			class="block h-full max-h-full p-4 xs:hidden"
			src="/img/svg/logo-icon.svg"
			alt={lang === "bg" ? "Вътрешен Глас" : "Inner Voice"}
		/>
		<button
			class=" ghost icon"
			style="margin-left:auto; margin-right:0"
			on:click={() => (
				(showLangSelector = false), (showHelpInfo = !showHelpInfo)
			)}
			title={ui.game.header.help_title}
		>
			{#if showHelpInfo}
				<i
					class="fa-solid fa-times fa-fw"
					aria-hidden="true"
					data-position="center"
				/>
			{:else}
				<i
					class="fa-solid fa-circle-question fa-fw"
					aria-hidden="true"
					data-position="center"
				/>
			{/if}
		</button>
		<button
			class="ghost icon"
			on:click={() => (
				(showHelpInfo = false), (showLangSelector = !showLangSelector)
			)}
			title={ui.game.header.lang_title}
		>
			{#if showLangSelector}
				<i
					class="fa-solid fa-times fa-fw"
					aria-hidden="true"
					data-position="center"
				/>
			{:else}
				<i
					class="fa-solid fa-language fa-fw"
					aria-hidden="true"
					data-position="center"
				/>
			{/if}
		</button>
		{#if showLangSelector}
			<div
				transition:slide
				class="absolute right-0 grid bg-blue-100 lang-selector top-20 bg-opacity-90"
			>
				<button on:click={() => ((lang = "bg"), (showLangSelector = false))}
					>Български (Bulgarian)</button
				>
				<button on:click={() => ((lang = "en"), (showLangSelector = false))}
					>English (Английски)</button
				>
			</div>
		{/if}
		{#if showHelpInfo}
			<div
				transition:slide
				class="absolute right-0 grid bg-blue-100 lang-selector top-20 bg-opacity-90 p-[10px] max-w-full"
			>
				<h3>{ui.help.title}</h3>
				<p>{ui.help.description}</p>

				<a href={ui.help.messenger_link}>{ui.help.messenger}</a>
				<a href={ui.help.instagram_link}>{ui.help.instagram}</a>
				<a href={ui.help.email_link}>{ui.help.email}</a>
			</div>
		{/if}
	</header>
{/if}
<main
	class="grid mx-auto font-light obelisk place-content-center 2xl:max-w-4xl lg:max-w-3xl"
>
	{#if !loader}
		<!--  -->
		<!-- LOGIN -->
		<!--  -->

		{#if state == "login_buttons"}
			<!-- LOGIN BUTTONS -->

			<div class="pb-8 font-light text-center text-balance">
				<h1>{ui.login.title}</h1>
				<br />
				<p>
					{ui.login.by_log_pre}
					<a href={ui.login.by_log_link}>{ui.login.by_log_title}</a>{ui.login
						.by_log_post}
				</p>
			</div>
			<!-- ЛОГИН     -->

			<div class="flex flex-wrap place-content-center">
				{#if lg.includes("g")}
					<button on:click={() => authWithGoogle()}
						><i class="fa-brands fa-google" data-position="left" />{ui.login
							.withGoogle}</button
					>
				{/if}
				{#if lg.includes("a")}
					<button on:click={() => anonymousCreator()}
						><i class="fa-solid fa-user-ninja" data-position="left" />{ui.login
							.anonymous}</button
					>
				{/if}
			</div>

			<div class="pt-8 font-light text-center">
				<p>
					<strong>{ui.login.no_mission_strong}</strong>{ui.login.no_mission_pre}
					<a href={ui.login.no_mission_link}>{ui.login.no_mission_title}</a>{ui
						.login.no_mission_post}
				</p>
			</div>

			<!-- <div class="max-w-prose place-content-center">
                Not sure what to do here?
            </div> -->
		{:else if state == "anon_creator"}
			<!-- ANONIMOUS CREATOR -->

			<User
				name={anonUser.name}
				photo={"data:image/png;base64," + anonUser.photo}
			/>

			<div class="flex flex-wrap justify-center place-self-center">
				<button on:click={() => create()} class="secondary"
					><i class="fa-solid fa-font" data-position="left" />{ui.login
						.anon_new_name}</button
				>
				<button on:click={() => create("image")} class="secondary"
					><i class="fa-solid fa-brush" data-position="left" />{ui.login
						.anon_new_image}</button
				>
			</div>

			{#if captchaState !== "success"}
				<div class="justify-center my-4 text-center place-self-center">
					<Recaptcha
						sitekey={googleRecaptchaSiteKey}
						badge={"inline"}
						size={"normal"}
						on:success={() => (captchaState = "success")}
						on:error={() => (captchaState = "error")}
						on:expired={() => (captchaState = "expired")}
						on:ready={() => (captchaState = "ready")}
					/>
					<p>
						<small>
							{ui.login.recaptcha_pre}<a
								href="https://www.google.com/recaptcha/about/"
								target="_blank"
								class="font-normal">{ui.login.recaptcha_name}</a
							>{ui.login.recaptcha_post}<a
								href="https://m.me/vutreshenglas"
								class="font-normal">{ui.login.recaptcha_getintouch}</a
							>{ui.login.recaptcha_end}</small
						>
					</p>
				</div>
			{/if}
			<div class="flex flex-wrap-reverse justify-center place-self-center">
				<button
					class="outline place-self-center"
					on:click={() => (state = "login_buttons")}
				>
					<i class="fa-solid fa-circle-left" data-position="left" />{ui.login
						.anon_back}
				</button>
				<button
					class=" place-self-center"
					on:click={() => authAnonymously()}
					disabled={captchaState !== "success" ? true : false}
				>
					<i class="fa-solid fa-circle-check" data-position="left" />{ui.login
						.anon_confirm}
				</button>
			</div>

			<!--  -->
			<!-- USER -->
			<!--  -->
		{:else if state == "user"}
			<div transition:slide class=" contents">
				<!-- USER with stepstates -->

				<User name={user.name} photo={user.photo} />

				{#if stepstate == "rules"}
					<!-- AGREE TO RULES -->
					<div class="flex mb-4 fullwidth justify-self-center">
						<input
							type="checkbox"
							id="rules-agree"
							bind:checked={agreedToRules}
							tabindex="0"
							required
						/>
						<label for="rules-agree">
							{ui.login.terms_pre}<a
								href={ui.login.terms_link}
								class="font-normal">{ui.login.terms_title}</a
							>{ui.login.terms_post}</label
						>
					</div>
					<button
						on:click={() => {
							checkActiveSession(user.uid);
							stepstate = "new_captain_join";
						}}
						disabled={!agreedToRules}
						class="place-self-center"
					>
						{ui.login.postrules_next}<i
							class="fas fa-circle-right"
							aria-hidden="true"
							data-position="right"
						/>
					</button>

					<!--  -->
					<!-- NEW -->
				{:else if stepstate == "new_captain_join"}
					<!-- NEW TEAM / JOIN TEAM -->

					<button
						on:click={() =>
							gc && fg
								? (stepstate = "team_name")
								: (stepstate = "game_captain")}
						disabled={!agreedToRules}
						class="place-self-center"
					>
						<i class="fa-solid fa-circle-plus" data-position="left" />{ui.login
							.new_team}
					</button>
					<button
						on:click={() => (stepstate = "game_join")}
						disabled={!agreedToRules}
						class="place-self-center"
					>
						<i class="fa-solid fa-user-plus" data-position="left" />{ui.login
							.join_team}
					</button>
				{:else if stepstate == "game_captain"}
					<!-- GAME ACCESS CODE -->
					<h1 class="text-center">{ui.new_join.enter_game_code}</h1>
					{#if gn}<p class="text-center">{gn}</p>{:else}<p class="text-center">
							{ui.new_join.game_code_description}
						</p>{/if}
					<input
						class="text-center place-self-center"
						type="text"
						bind:value={sessionData.gameAccCode}
						on:keypress={() => (nextstepstate = "team_name")}
						on:keypress={(e) => nextStep(e)}
						placeholder={ui.new_join.game_code_placeholder}
						maxlength="10"
					/>

					<!-- TODO: add keypress enter next step functionallity -->

					<div class="flex flex-wrap-reverse justify-center place-self-center">
						<button
							on:click={() => (stepstate = "new_captain_join")}
							disabled={!agreedToRules}
						>
							<i class="fa-solid fa-circle-left" data-position="left" />{ui
								.new_join.back}</button
						>

						<button
							on:click={() => (stepstate = "team_name")}
							disabled={sessionData.gameAccCode == "" ||
							sessionData.gameAccCode == null ||
							sessionData.gameAccCode.length < 7
								? true
								: false}
							>{ui.new_join.next}<i
								class="fa-solid fa-circle-right"
								data-position="right"
							/>
						</button>
					</div>
				{:else if stepstate == "team_name"}
					<!-- TEAM NAME -->
					<h1 class="text-center">{ui.new_join.enter_team_name}</h1>
					<p class="text-center">{ui.new_join.team_name_description}</p>

					<input
						class="text-center place-self-center"
						type="text"
						maxlength="256"
						bind:value={sessionData.teamName}
						placeholder={ui.new_join.team_name_placeholder}
					/>
					<div class="flex flex-wrap-reverse justify-center place-self-center">
						<button
							on:click={() => (stepstate = "game_captain")}
							disabled={!agreedToRules}
						>
							<i class="fa-solid fa-circle-left" data-position="left" />{ui
								.new_join.back}
						</button>
						<button
							on:click={() => newGame()}
							disabled={sessionData.teamName == "" ||
							sessionData.teamName == null
								? true
								: false}
						>
							{ui.new_join.next}<i
								class="fa-solid fa-circle-right"
								data-position="right"
							/>
						</button>
					</div>
					<!--  -->
					<!-- JOIN -->
					<!--  -->
				{:else if stepstate == "game_join"}
					<!-- GAME JOIN CODE -->
					<h1 class="text-center">{ui.new_join.enter_session_code}</h1>
					<p class="text-center">{ui.new_join.session_code_description}</p>
					<div class="flex justify-center font-normal place-self-center">
						<i class="fa-solid fa-key input-icon secondary" />
						<input
							class="text-center place-self-center secondary"
							type="text"
							bind:value={sessionData.joinCode}
							placeholder={ui.new_join.session_code_placeholder}
							maxlength="5"
							size="7"
						/>
					</div>
					<div
						class="flex flex-wrap-reverse justify-center font-normal place-self-center"
					>
						<button
							on:click={() => (stepstate = "new_captain_join")}
							disabled={!agreedToRules}
						>
							<i class="fa-solid fa-circle-left" data-position="left" />{ui
								.new_join.back}
						</button>

						<button
							on:click={() => getSessionID()}
							disabled={sessionData.joinCode == "" ||
							sessionData.joinCode == null ||
							sessionData.joinCode.length < 3
								? true
								: false}
						>
							<i class="fa-solid fa-user-plus" data-position="left" />{ui
								.new_join.join}</button
						>
					</div>
				{/if}

				<!-- {#if typeof user.pastSessions !== 'undefined' && user.pastSessions.length > 0}
                <button class="outline" on:click={() => console.log(user.pastSessions)}
                    ><i class="fa-solid fa-clock-rotate-left" /> Show my past sessions</button
                >
            {/if} -->

				<!-- <button
					class="outline place-self-center"
					on:click={() => auth.signOut()}
				>
					<i class="fas fa-door-open" data-position="left" />{ui.global.log_out}
				</button> -->
				<button
					class="outline place-self-center"
					on:click={() => {
						if (window.confirm(ui.global.log_out_confirm)) {
							auth.signOut();
						}
					}}
				>
					<i class="fas fa-door-open" data-position="left" />{ui.global.log_out}
				</button>
			</div>
		{:else if state == "session"}
			{#if sessionData.game}
				<div
					transition:slide
					class=" role-{sessionData?.session?.players[user.uid].role ||
						'default'} variant-{sessionData?.teamVariant
						? sessionData?.teamVariant
						: 'default'} contents"
				>
					<!-- mx-auto 2xl:max-w-4xl lg:max-w-3xl obelisk -->

					<h1 class="text-center">
						{typeof sessionData.game.name === "object"
							? sessionData.game.name[lang]
							: sessionData.game.name}
					</h1>
					<h3 class="text-center">{sessionData.session.team_name}</h3>
					<br />
					{#if sessionData.game.start && sessionData.game.start.title !== ""}
						<p class="mx-auto text-center">
							<i class="mr-2 fa-solid fa-compass" />{ui.new_join
								.starting_location}:
							{#if sessionData.game.start.link}
								<a
									href={sessionData.game.start.link}
									target="_blank"
									class="font-normal">{sessionData.game.start.title}</a
								>
							{:else}
								{sessionData.game.start.title}
							{/if}
						</p>
						<br />
					{/if}
					<div
						class="flex flex-wrap justify-center font-normal place-self-center"
					>
						<button
							id="game_access_code"
							class="default flex justify-center place-self-center relative group"
							on:click={() => copyCode(sessionData.access_code)}
							on:blur={() => outFunc()}
						>
							<!--  on:click={() => copyCode(sessionData.access_code)} -->
							<i class="fa-solid fa-key input-icon secondary" />
							<span class="text-center place-self-center secondary igroup-text"
								>{sessionData.access_code}</span
							>
							<!-- Add Copy Code here -->
							<span
								class="absolute -top-5 text-sm group-hover:opacity-100 group-focus:opacity-100 px-3 py-1 bg-blue-200 opacity-0 transition-all"
								id="myTooltip">{ui.new_join.copy_code}</span
							>
							<!-- <div class="tooltip absolute bottom-0">
							<button onclick="myFunction()" onmouseout="outFunc()">
								
								Copy text
							</button>
						</div> -->
						</button>

						<div
							class="flex justify-center place-self-center"
							id="game_players_limit"
						>
							<i class="fa-solid fa-user input-icon" />
							<span class="text-center place-self-center igroup-text"
								>{Object.keys(sessionData.session.players).length} / {sessionData
									.game.limit}</span
							>
						</div>
					</div>

					<p class="mx-auto text-center" id="game_players_limit_context">
						{Object.keys(sessionData.session.players).length ==
						sessionData.game.limit
							? ui.new_join.invite_no_more
							: ui.new_join.invite_more}
					</p>

					<ul class="flex flex-wrap gap-6 my-8" id="game_players_list">
						{#each sessionData.session.playersArray as user}
							<User
								name={user.name}
								photo={user.pic}
								role={sessionData.session.players[user.uid].role}
							/>
						{/each}
					</ul>

					<Tutorial {lang} gid={sessionData.game.gid} {db} />

					<button
						id="game_start_button"
						class="justify-center place-self-center"
						on:click={() => startGameSession()}
					>
						<!-- TODO: add confirmation to start btn -->
						<i class="fa-solid fa-flag-checkered" data-position="left" />{ui
							.new_join.start_game}
					</button>
					<p class="mx-auto mb-5 text-center">{ui.new_join.make_sure}</p>
					{#if Object.keys(sessionData.session.players).length > 1}
						<button
							class="justify-center outline place-self-center"
							on:click={() => leaveSession()}
						>
							<i
								class="fa-solid fa-right-from-bracket"
								data-position="left"
							/>{ui.new_join.leave_session}
						</button>
					{/if}

					<button
						class="mt-10 outline place-self-center"
						on:click={() => auth.signOut()}
					>
						<i class="fas fa-door-open" data-position="left" />
						{ui.global.log_out}
					</button>
				</div>
			{:else}
				<div class="text-center" transition:slide>
					<div class="mb-5 fa-2x">
						<i class="fa-solid fa-circle-notch fa-spin" />
					</div>
					<p>{ui.global.loading}</p>
				</div>
			{/if}
		{/if}

		{#if state == "game"}
			<h2>THE GAME IS ON!</h2>
			<button class="outline" on:click={() => leaveSession()}>
				<i class="fa-solid fa-right-from-bracket" />Leave session
			</button>
		{/if}
	{/if}
</main>
<GameFooter {lang} />

<style>
	:global(.g-recaptcha) {
		display: inline-block;
	}
</style>
